import { Field, Input as ChakraInput } from "@chakra-ui/react";
import { forwardRef } from "react";
import { getThemeColor } from "theme/colors";

interface InputProps extends React.ComponentProps<typeof ChakraInput> {
  label?: string;
  helperText?: string;
  errorText?: string;
  required?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, helperText, errorText, required, ...props }, ref) => {
    const inputStyles = {
      bg: getThemeColor("input.bg"),
      borderColor: getThemeColor("input.border"),
      color: getThemeColor("input.text"),
      _placeholder: {
        color: getThemeColor("input.placeholder"),
      },
      _focus: {
        borderColor: getThemeColor("input.borderFocus"),
        boxShadow: `0 0 0 1px ${getThemeColor("input.borderFocus").base}`,
        _dark: {
          boxShadow: `0 0 0 1px ${getThemeColor("input.borderFocus")._dark}`,
        },
      },
      ...props,
    };

    if (label || helperText || errorText) {
      return (
        <Field.Root invalid={!!errorText} required={required}>
          {label && <Field.Label>{label}</Field.Label>}
          <ChakraInput ref={ref} {...inputStyles} />
          {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
          {errorText && <Field.ErrorText>{errorText}</Field.ErrorText>}
        </Field.Root>
      );
    }

    return <ChakraInput ref={ref} {...inputStyles} />;
  },
);

Input.displayName = "Input";
